import { render, staticRenderFns } from "./LsCustomerLeads.vue?vue&type=template&id=029c3476&"
import script from "./LsCustomerLeads.vue?vue&type=script&lang=js&"
export * from "./LsCustomerLeads.vue?vue&type=script&lang=js&"
import style0 from "./LsCustomerLeads.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports